import styled, { css } from 'styled-components';

export const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: ${theme.sz.s8} ${theme.sz.s4};
    background-color: ${theme.co.neutral99};
    border-radius: ${theme.bo.mediumSmall};
    margin: 0 auto;
    gap: ${theme.sz.s4};
    min-height: ${theme.sz.ms};

    @media (max-width: ${theme.sz.m}) {
      height: 100%;
      border-radius: 0;
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.neutral0};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.neutral0};
    margin: 0;
  `,
);
